// import React from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Navbar from "components/navbar";
// import Sidebar from "components/sidebar";
// import Footer from "components/footer/Footer";
// import routes from "routes.js";

// export default function Admin(props) {
//   const { ...rest } = props;
//   const location = useLocation();
//   const [open, setOpen] = React.useState(true);
//   const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

//   React.useEffect(() => {
//     window.addEventListener("resize", () =>
//       window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
//     );
//   }, []);
//   React.useEffect(() => {
//     getActiveRoute(routes);
//   }, [location.pathname]);

//   const getActiveRoute = (routes) => {
//     let activeRoute = "Main Dashboard";
//     for (let i = 0; i < routes.length; i++) {
//       if (routes[i].children) {
//         for (let j = 0; j < routes[i].children.length; j++) {
//           const child = routes[i].children[j];
//           if (
//             window.location.href.indexOf(child.layout + "/" + child.path) !== -1
//           ) {
//             setCurrentRoute(child.name);
//             return activeRoute;
//           }
//         }
//       }
//       if (
//         window.location.href.indexOf(
//           routes[i].layout + "/" + routes[i].path
//         ) !== -1
//       ) {
//         setCurrentRoute(routes[i].name);
//       }
//     }
//     return activeRoute;
//   };
//   const getActiveNavbar = (routes) => {
//     let activeNavbar = false;
//     for (let i = 0; i < routes.length; i++) {
//       if (
//         window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
//       ) {
//         return routes[i].secondary;
//       }
//     }
//     return activeNavbar;
//   };
//   const getRoutes = (routes) => {
//     return routes.flatMap((prop, key) => {
//       if (prop.children) {
//         return prop.children
//           .filter((child) => child.component)
//           .map((child, childKey) => (
//             <Route
//               path={`/${child.path}`}
//               element={child.component}
//               key={`${key}-${childKey}`}
//             />
//           ));
//       }

//       if (prop.layout === "/admin" && prop.component) {
//         return [
//           <Route path={`/${prop.path}`} element={prop.component} key={key} />,
//         ];
//       }

//       return [];
//     });
//   };

//   document.documentElement.dir = "ltr";
//   return (
//     <div className="h-full w-full p-1">
//       <div className="flex h-full w-ful ">
//         <Sidebar open={open} onClose={() => setOpen(false)} />
//         <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
//           <main
//             className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
//           >
//             <div className="h-full">
//               <Navbar
//                 onOpenSidenav={() => setOpen(true)}
//                 logoText={"Horizon UI Tailwind React"}
//                 brandText={currentRoute}
//                 secondary={getActiveNavbar(routes)}
//                 {...rest}
//               />
//               <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-6 md:pr-2">
//                 <Routes>
//                   {getRoutes(routes)}

//                   <Route
//                     path="/"
//                     element={<Navigate to="/admin/default" replace />}
//                   />
//                 </Routes>
//               </div>
//               <div className="p-3">
//                 <Footer />
//               </div>
//             </div>
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [collapsed, setCollapsed] = React.useState(false);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");
  const [activeRouteList, setActiveRouteList] = React.useState([]);

  React.useEffect(() => {
    const handleResize = () => {
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    getActiveRoute(routes);
    setActiveRouteList(getActivePath(routes));
  }, [location.pathname]);
  // =====================================================
  // AUTHENTICATION CHECK
  // =====================================================
  const token = localStorage.getItem("accessToken");




  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";
    console.log("getActiveRoute", window.location.href);
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].children) {
        for (let j = 0; j < routes[i].children.length; j++) {
          const child = routes[i].children[j];
          if (
            window.location.href.indexOf(child.layout + "/" + child.path) !== -1
          ) {
            setCurrentRoute(child.name);
            return activeRoute;
          }
        }
      }
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };

  const getActivePath = (routes) => {
    try {
      let pathSegments = window.location.href.split("/").filter(Boolean);
      const editExisting = window.location.href.includes("edit");
      let lastTwoSegments = [];
      console.log(pathSegments)

      if (editExisting) {
        pathSegments.pop(); // Remove trailing ID or subpath
        pathSegments.push(":id");
        lastTwoSegments = pathSegments.slice(-3);
      } else {
        lastTwoSegments = pathSegments.slice(-2);
      }
      console.log(lastTwoSegments)

      if (lastTwoSegments.length === 0) return [];

      // Helper: Flatten all nested routes (parent + children) into a single array
      const flattenRoutes = (routeList) => {
        return routeList.reduce((acc, route) => {
          acc.push(route);
          if (route.children && Array.isArray(route.children)) {
            acc.push(...flattenRoutes(route.children));
          }
          return acc;
        }, []);
      };

      const allRoutes = flattenRoutes(routes);

      const lastPathName = lastTwoSegments[lastTwoSegments.length - 1].replace(
        /-/g,
        " "
      );
      console.log("lastPathName",lastPathName)

      // 1. Check match by last segment path
      const matchedByName = allRoutes.find(
        (route) =>
          (route.path && route.path.toLowerCase() === lastPathName.toLowerCase()) || (route.name && route.name.toLowerCase() === lastPathName.toLowerCase() )
      );
      console.log("matchedByName",matchedByName)

      if (matchedByName) {
        return [matchedByName];
      } else {
        const concatPath = lastTwoSegments.join("/");

        // 2. Check match by combined path (e.g. "exhibitor-events/:id")
        const matchedByPath = allRoutes.find(
          (route) =>
            route.path && route.path.toLowerCase() === concatPath.toLowerCase()
        );

        if (matchedByPath) {
          // Safe shallow clone to avoid mutating original route config
          const formattedChild = { ...matchedByPath, name: lastTwoSegments[1] };

          const firstSegmentName = lastTwoSegments[0].replace(/-/g, " ");
          const matchedByFirstSegment = allRoutes.find(
            (route) =>
              route.path &&
              route.path.toLowerCase() === firstSegmentName.toLowerCase()
          );

          return [matchedByFirstSegment, formattedChild].filter(Boolean);
        }

        return [];
      }
    } catch (error) {
      console.error("getActivePath error:", error);
      return [];
    }
  };

  const getActiveNavbar = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return false;
  };

  const getRoutes = (routes) => {
    return routes.flatMap((prop, key) => {
      if (prop.children) {
        return prop.children
          .filter((child) => child.component)
          .map((child, childKey) => (
            <Route
              path={`/${child.path}`}
              element={child.component}
              key={`${key}-${childKey}`}
            />
          ));
      }

      if (prop.layout === "/admin" && prop.component) {
        return [
          <Route path={`/${prop.path}`} element={prop.component} key={key} />,
        ];
      }

      return [];
    });
  };

  document.documentElement.dir = "ltr";
  // If token does not exist, go to login page
  if (!token) {
    return <Navigate to="/auth/sign-in" replace />;
  }
  return (
    // 1. Root Screen Container
    <div
      className="h-screen w-screen overflow-hidden0"
      style={{
        background:
          "linear-gradient(to right, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 30%, #FFFFFF 70%, #FFFFFF 100%)",
      }}
    >
      <div className="relative flex h-full w-full">
        {/* Sidebar */}
        <Sidebar
          open={open}
          onClose={() => setOpen(false)}
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed(!collapsed)}
        />

        {/* 2. Main Content Wrapper */}
        <div
          className="flex h-full w-full min-w-0 flex-col transition-all duration-300"
          style={{ background: "rgba(255, 255, 255, 0.10)" }}
        >
          <main
            className={`flex h-full flex-col transition-all duration-300 lg:pr-[15px] ${
              collapsed ? "xl:ml-[96px]" : "xl:ml-[300px]"
            }`}
          >
            {/* 3. STATIC NAVBAR HEADER */}
            <header className="z-30 shrink-0 px-3 pt-2">
              <Navbar
                onOpenSidenav={() => setOpen(true)}
                logoText={"Horizon UI Tailwind React"}
                brandText={currentRoute}
                secondary={getActiveNavbar(routes)}
                activeRouteList={activeRouteList}
                {...rest}
              />
            </header>

            {/* 4. FULL-HEIGHT CONTENT AREA (Fills all remaining vertical space) */}
            <div className="flex min-h-0 w-full flex-1 flex-col overflow-hidden ">
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={<Navigate to="/admin/default" replace />}
                />
              </Routes>
            </div>

            {/* 5. STATIC FOOTER */}
            {/* <footer className="shrink-0 px-3 pb-2">
              <Footer />
            </footer> */}
          </main>
        </div>
      </div>
    </div>
  );
}
